// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.task-bar {
  position: relative;
  display: flex;
  justify-content: center;  
  margin-top: 7%;
  flex-wrap: wrap;
  width: 100%;
  overflow: hidden;
}

.task-bar::-webkit-scrollbar{display: none;}

.dsply{
  position: relative;
  display: flex;
  width: 100%;
  height: -moz-fit-content;
  height: fit-content;
  justify-content: center;
}

.taskbar-nav {
  position: relative;
  display: flex;
  width: 821px;
  height: 53px;
  border-radius: 8px;
  box-shadow: 10px 10px 20px rgba(0, 0, 0, 0.5);
  justify-content: space-between;
  align-items: center;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  border-top: 1px solid var(--text-color);
  border-left: 1px solid var(--text-color);
  -webkit-backdrop-filter: blur(3px);
          backdrop-filter: blur(3px);
  cursor: pointer;
}

.taskbar-button {
  padding: 0rem 2rem;
  font-size: 20px;
  font-family: Georgia, 'Times New Roman', Times, serif;
  font-weight: 700;
  text-transform: uppercase;
  color: var(--main-color);
  line-height: 50px;
  border-radius: 8px;
  border-color: transparent;
  border-right: 1px solid var(--text-color);
  background: none;
  transition: background-color 0.1s;
  cursor: pointer;
}


.taskbar-button.active {
  background-color: var(--main-color);
  color: var(--text-color);
  transition: .5s;
}

.taskbar-animation {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 2px;
  background: var(--text-color);
  transition: 0.5s;
  z-index: 100;
}

.start-abou {
  width: 142px;
  left: 0;
}

.start-time {
  width: 178px;
  left: 143px;
}

.start-achive {
  width: 246px;
  left: 321px;
}

.start-cert {
  width: 253px;
  left: 566px;
}`, "",{"version":3,"sources":["webpack://./src/components/About/Taskbar/Taskbar.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,6BAA6B,aAAa,CAAC;;AAE3C;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,wBAAmB;EAAnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,6CAA6C;EAC7C,8BAA8B;EAC9B,mBAAmB;EACnB,oCAAoC;EACpC,kBAAkB;EAClB,uCAAuC;EACvC,wCAAwC;EACxC,kCAA0B;UAA1B,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,qDAAqD;EACrD,gBAAgB;EAChB,yBAAyB;EACzB,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,yCAAyC;EACzC,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;AACjB;;;AAGA;EACE,mCAAmC;EACnC,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,6BAA6B;EAC7B,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb","sourcesContent":[".task-bar {\n  position: relative;\n  display: flex;\n  justify-content: center;  \n  margin-top: 7%;\n  flex-wrap: wrap;\n  width: 100%;\n  overflow: hidden;\n}\n\n.task-bar::-webkit-scrollbar{display: none;}\n\n.dsply{\n  position: relative;\n  display: flex;\n  width: 100%;\n  height: fit-content;\n  justify-content: center;\n}\n\n.taskbar-nav {\n  position: relative;\n  display: flex;\n  width: 821px;\n  height: 53px;\n  border-radius: 8px;\n  box-shadow: 10px 10px 20px rgba(0, 0, 0, 0.5);\n  justify-content: space-between;\n  align-items: center;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  border-top: 1px solid var(--text-color);\n  border-left: 1px solid var(--text-color);\n  backdrop-filter: blur(3px);\n  cursor: pointer;\n}\n\n.taskbar-button {\n  padding: 0rem 2rem;\n  font-size: 20px;\n  font-family: Georgia, 'Times New Roman', Times, serif;\n  font-weight: 700;\n  text-transform: uppercase;\n  color: var(--main-color);\n  line-height: 50px;\n  border-radius: 8px;\n  border-color: transparent;\n  border-right: 1px solid var(--text-color);\n  background: none;\n  transition: background-color 0.1s;\n  cursor: pointer;\n}\n\n\n.taskbar-button.active {\n  background-color: var(--main-color);\n  color: var(--text-color);\n  transition: .5s;\n}\n\n.taskbar-animation {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  height: 2px;\n  background: var(--text-color);\n  transition: 0.5s;\n  z-index: 100;\n}\n\n.start-abou {\n  width: 142px;\n  left: 0;\n}\n\n.start-time {\n  width: 178px;\n  left: 143px;\n}\n\n.start-achive {\n  width: 246px;\n  left: 321px;\n}\n\n.start-cert {\n  width: 253px;\n  left: 566px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
